export default __webpack_public_path__ + "static/media/withdrawIcon.a4c548b9.svg";